import styled from "styled-components";

import { Box, FlexBox, Heading } from "@braze/beacon-core";
import { getColor, getSpacing } from "@braze/beacon-styling";

const backgroundGradient =
  "https://s3.us-east-1.amazonaws.com/appboy-images.com/dashboard-assets/dashboard/free-trial-reg/Supergraphic.png";

export const PageBackground = styled(FlexBox)`
  width: 100%;
  height: 100vh;
  flex-direction: column;
  align-items: center;
`;

export const BackgroundGradient = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: inherit;
  object-fit: contain;
  z-index: -1;
  background-color: #300266;
`;

export const BackgroundImage = styled(Box)`
  background-image: url(${backgroundGradient});
  background-size: 1485.402px 1727.481px;
  background-position: 700px -300px;
  background-repeat: no-repeat;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: inherit;
  object-fit: contain;
  z-index: -1;
  opacity: 0.45;
`;

export const HeaderLogo = styled.img`
  height: 78px;
  z-index: 2;
  margin-bottom: ${getSpacing("xl")};
`;

export const Content = styled(FlexBox)`
  height: calc(max-content - 80px);
  @media (min-width: 1220px) {
    min-height: 924px;
  }
`;

export const Overlay = styled(FlexBox)`
  border-radius: ${getSpacing("lg")};
  padding: ${getSpacing("xl")};
  border: 0.575px solid var(--Base-White, #fff);
  background: rgba(255, 255, 255, 0.5);
  box-shadow:
    0px 1.598px 3.874px 0px rgba(48, 2, 102, 0.05),
    0px 0.665px 1.612px 0px rgba(48, 2, 102, 0.03);
  backdrop-filter: blur(11.49376392364502px);
  width: 575px;
  @media (max-width: 1024px) {
    margin: auto;
  }
  @media (max-width: 625px) {
    width: 100%;
    margin: 0;
    padding: 0;
    border: none;
    background: none;
    box-shadow: none;
  }
`;

export const FormContainer = styled(FlexBox)`
  flex-direction: column;
  padding: ${getSpacing("xxl")};
  width: inherit;
  background: ${getColor("gray", 50)};
  margin: auto;
  border-radius: ${getSpacing("lg")};

  // addresses the default yellow background highlight that browsers apply to input fields when they're autofilled
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-background-clip: text;
    -webkit-text-fill-color: #000000;
    transition: background-color 5000s ease-in-out 0s;
  }
`;

export const MainContent = styled(FlexBox)`
  padding: 5vh 5vh 10vh 5vh;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  @media (max-width: 1024px) {
    padding-top: 0;
    flex-direction: column;
    align-items: center;
  }
  @media (max-width: 625px) {
    padding: 0;
  }
`;

export const StyledHeading = styled(Heading)`
  color: ${getColor("gray", 0)};
  text-align: center;
  padding: 12px 24px;
  width: calc(100% - 48px);
  margin-bottom: ${getSpacing("xl")};
  @media (min-width: 1024px) {
    display: none;
  }
  @media (max-width: 500px) {
    font-size: 24px;
  }
`;

export const LanguagePickerWrapper = styled(FlexBox)`
  width: 100%;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: ${getSpacing("md")};
  @media (max-width: 1024px) {
    display: none;
  }
`;
